import { render, staticRenderFns } from "./addCraft.vue?vue&type=template&id=438fda28&scoped=true"
import script from "./addCraft.vue?vue&type=script&lang=js"
export * from "./addCraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438fda28",
  null
  
)

export default component.exports